import React from 'react';
import { useTranslation } from "react-i18next";
import styled from "styled-components";


const EnableSpan = styled.span`
    color:'#008557';
`;
const DisableSpan = styled.span`
    color:'#757575';
`;
const StatusCell = (props: {status: boolean}) => {
    const { t } = useTranslation();
    return (
        props.status ? <EnableSpan style={{color:'#008557'}}>{t('enabled')}</EnableSpan> : <DisableSpan style={{color:'#757575'}}>{t('disabled')}</DisableSpan>
    )
}

export default StatusCell;